var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAscending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.788,
    height: 9.486,
    viewBox: "0 0 15.788 9.486",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.545 -21.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.545 21.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.882,30.761a.513.513,0,0,0,.848,0l2.245-3.242a.507.507,0,0,0-.416-.8H6.212V21.916A.412.412,0,0,0,5.8,21.5H4.832a.412.412,0,0,0-.416.416v4.805H3.053a.507.507,0,0,0-.416.8Z",
    transform: "translate(-2.545 -21.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4,67.7H44.316a.412.412,0,0,0-.416.416v.964a.412.412,0,0,0,.416.416H52.4a.412.412,0,0,0,.416-.416v-.964A.412.412,0,0,0,52.4,67.7Z",
    transform: "translate(-37.024 -60.018)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.316,46.5h6.268A.412.412,0,0,0,51,46.08v-.964a.412.412,0,0,0-.416-.416H44.316a.412.412,0,0,0-.416.416v.964A.422.422,0,0,0,44.316,46.5Z",
    transform: "translate(-37.024 -40.843)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.316,23.4h4.456a.412.412,0,0,0,.416-.416v-.964a.412.412,0,0,0-.416-.416H44.316a.412.412,0,0,0-.416.416v.964A.412.412,0,0,0,44.316,23.4Z",
    transform: "translate(-37.024 -21.583)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAscending);
export default __webpack_public_path__ + "static/media/ascending.a27bc66a94381faca2c3554da0e41105.svg";
export { ForwardRef as ReactComponent };